// extracted by mini-css-extract-plugin
export var banner = "exercise-page-module--banner--85964";
export var bannerContent = "exercise-page-module--bannerContent--6dd9f";
export var cluesBox = "exercise-page-module--clues-box--fd344";
export var description = "exercise-page-module--description--666ec";
export var loader = "exercise-page-module--loader--221c1";
export var relatedExercises = "exercise-page-module--relatedExercises--47f84";
export var relatedSeparator = "exercise-page-module--relatedSeparator--e8a12";
export var seeAllButton = "exercise-page-module--seeAllButton--916ad";
export var separator = "exercise-page-module--separator--ee92e";
export var video = "exercise-page-module--video--46daa";
export var wrapper = "exercise-page-module--wrapper--661d9";